import React from "react"
import { Paper, Toggle } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IWorkPoolEmployee } from "../../../models"
import TableActionBar from "../../../components/layout/TableActionBar"
import AppStateStore from "../../../stores/AppStateStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import CandidateDeclineDialog from "../../../pages/jobs/job-details/job-detail-worker-pool/worker-pool-detail/CandidateDeclineDialog"
import ShiftWorkPoolEmployeeTable from "./ShiftWorkPoolEmployeeTable"

interface IProps {
    readonly?: boolean
    requestedCandidates: IWorkPoolEmployee[]
    shortListCandidate(employeeId: string): void
    declineCandidateOnJob(userId: string, declineNote: string): void
    assignEmployeeToShift:(employee:IWorkPoolEmployee) => void
}
interface IState {
    requestedCandidates: IWorkPoolEmployee[]
    selectedRequestedCandidates: IWorkPoolEmployee[]
    offset: number
    limit: number
    expanded: boolean
    showArchived: boolean
    openDeclineDialog: boolean
    showTable: boolean
}

export default class ShiftRequestedCandidates extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            requestedCandidates: props.requestedCandidates,
            selectedRequestedCandidates: [],
            offset: 0,
            limit: 20,
            expanded: false,
            showArchived: true,
            openDeclineDialog: false,
            showTable: true,
        }
        autobind(this)
    }

    componentWillReceiveProps (newProps) {
        if (this.props.requestedCandidates !== newProps.requestedCandidates) {
            this.setState({ requestedCandidates: newProps.requestedCandidates })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.requestedCandidates !== prevProps.requestedCandidates) {
            this.setState({ requestedCandidates: this.props.requestedCandidates })
        }
    }


    render() {
        const viewableEmployees = this.state.requestedCandidates.slice(this.state.offset, Math.min(this.state.offset + this.state.limit, this.state.requestedCandidates.length))
        return (
            <Paper zDepth={1}>
                <div style={{ position: "relative", }}>
                    <div style={{ fontSize: 15, fontWeight: "bold", padding: 25 }}>
                        {strings.Candidate_Requested}
                    </div>
                   {this.state.expanded &&
                         <div>
                            {this.props.requestedCandidates.length !== 0 &&
                                <Toggle
                                    onToggle={(e, checked) =>
                                        this.setState({ showArchived: checked }, () => {
                                            if (!this.state.showArchived) {
                                                const requestedCandidates = this.state.requestedCandidates.slice().filter(item => item.ArchivedByUserIds.length === 0)
                                                this.setState({ requestedCandidates })
                                            } else {
                                                this.setState({ requestedCandidates: this.props.requestedCandidates })
                                            }
                                        })
                                    }
                                    style={{ width: 200, position: "absolute", right: 60 }}
                                    defaultToggled={this.state.showArchived}
                                    label={strings.Show_Archived}
                                    disabled={this.props.readonly}
                                />
                            }
                            <br></br>
                            <TableActionBar
                                searchText={""}
                                rowSelectionCount={this.state.selectedRequestedCandidates.length}
                                singleSelectedMessage={strings.Employee_Selected}
                                multipleSelectedMessage={strings.x_Employees_Selected}
                                onDeclineSelectedItem={() => {
                                    if (this.state.selectedRequestedCandidates[0].Id === AuthenticationStore.getLoggedInUser().Id && !this.state.selectedRequestedCandidates[0].Declined) {
                                        AppStateStore.setProgressSnackbarContent(strings.You_Cant_Decline_Your_Own_Self)
                                    } else {
                                        if (!this.state.selectedRequestedCandidates[0].Declined) this.setState({ openDeclineDialog: true })
                                        else AppStateStore.setProgressSnackbarContent(strings.Already_Declined_Employee)
                                    }
                                }}
                                readonly={this.props.readonly}
                            />
                            {this.state.showTable &&
                                <ShiftWorkPoolEmployeeTable
                                    tableName={"requested"}
                                    saveColumn
                                    singleSelectable
                                    readonly={this.props.readonly}
                                    workPoolEmployees={viewableEmployees}
                                    selectedCandidates={this.state.selectedRequestedCandidates}
                                    offset={this.state.offset}
                                    limit={this.state.limit}
                                    limitOptions={[20, 50, 100]}
                                    total={this.state.requestedCandidates.length}
                                    onPageClick={offset => this.setState({ offset })}
                                    onLimitChange={limit => this.setState({ limit, offset: 0 })}
                                    shortListCandidate={this.props.shortListCandidate}
                                    handleSelectedCandidates={selectedRequestedCandidates => this.setState({ selectedRequestedCandidates })}
                                    assignEmployeeToShift={this.props.assignEmployeeToShift}
                                />
                            }
                        </div>
                   }
                    <div style={{ position: "absolute", right: 15, top: 15, fontSize: 18 }}>
                        <i
                            className={"fa " + (this.state.expanded ? "fa-chevron-up" : "fa-chevron-down") + " itemActionButton"}
                            onClick={() => this.setState({ expanded: !this.state.expanded })}
                        />
                    </div>
                </div>
                <CandidateDeclineDialog 
                    open={this.state.openDeclineDialog}
                    handleClose={() => this.setState({ selectedRequestedCandidates: [], openDeclineDialog: false, showTable: false }, () => this.setState({ showTable: true }))}
                    declineCandidateOnJob={(declineNote: string) => {
                        const employeeId = this.state.selectedRequestedCandidates[0].Id
                        this.setState({ selectedRequestedCandidates: [], openDeclineDialog: false, showTable: false }, () => {
                            this.setState({ showTable: true }, () => this.props.declineCandidateOnJob(employeeId, declineNote))
                            
                        })
                    }}
                />
            </Paper>
        )
    }
}